import { render, staticRenderFns } from "./RootsAndSquaresPreview.vue?vue&type=template&id=a649e9bc&lang=pug&"
import script from "./RootsAndSquaresPreview.vue?vue&type=script&lang=js&"
export * from "./RootsAndSquaresPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports